import { render, staticRenderFns } from "./RoadConceptForm.vue?vue&type=template&id=f89c1202"
import script from "./RoadConceptForm.vue?vue&type=script&lang=js"
export * from "./RoadConceptForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/RoadConceptsAdvance/RoadConceptForm.vue
// module id = 2179
// module chunks = 31